import React from "react";
import { withTranslation } from "react-i18next";

class Faq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: null,
    };
  }

  toggleAccordion = (index) => {
    this.setState((prevState) => ({
      activeIndex: prevState.activeIndex === index ? null : index,
    }));
  };
  render() {
    const { t } = this.props;
    const accordionData = [
      {
        title: t("question_6.text"),
        content: t("answer_6.text"),
      },
      {
        title: t("question_1.text"),
        content:
          t("answer_1.text"),
      },
      {
        title: t("question_2.text"),
        content:
          t("answer_2.text"),
      },
      {
        title: t("question_3.text"),
        content:
          t("answer_3.text"),
      },
      {
        title: t("question_4.text"),
        content:
          t("answer_4.text"),
      },
      {
        title: t("question_5.text"),
        content:
          t("answer_5.text"),
      }
      
    ];

    const half = Math.ceil(accordionData.length / 2);
    const firstColumnData = accordionData.slice(0, half);
    const secondColumnData = accordionData.slice(half);

    return (
      <>
        <h1 style={{marginBottom: "3rem"}}>{t("FAQ.text")}</h1>
        <div className="row d-flex justify-content-between">
          <div className="col-md-5">
            <div className="accordion">
              {firstColumnData.map((item, index) => (
                <div
                  className={`accordion-item ${
                    this.state.activeIndex === index ? "open" : ""
                  }`}
                  key={index}
                >
                  <a
                    className="accordion-link"
                    onClick={() => this.toggleAccordion(index)}
                  >
                    <div>
                      <h3>{item.title}</h3>
                    </div>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="12"
                      viewBox="0 0 22 12"
                      fill="none"
                    >
                      <path d="M21 0.999999L11 11L1 1" stroke="#01091C" />
                    </svg>
                  </a>
                  <div className="answer">
                    <p>{item.content}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-md-5">
            <div className="accordion">
              {secondColumnData.map((item, index) => (
                <div
                  className={`accordion-item ${
                    this.state.activeIndex === index + half ? "open" : ""
                  }`}
                  key={index}
                >
                  <a
                    className="accordion-link"
                    onClick={() => this.toggleAccordion(index + half)}
                  >
                    <div>
                      <h3>{item.title}</h3>
                    </div>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="12"
                      viewBox="0 0 22 12"
                      fill="none"
                    >
                      <path d="M21 0.999999L11 11L1 1" stroke="#01091C" />
                    </svg>
                  </a>
                  <div className="answer">
                    <p>{item.content}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(Faq);
